/**
 * useConnectivity – detect online/offline state
 *
 * Returns `{ isOnline }` that reactively tracks the browser's
 * connectivity. Components can use this to show an offline banner
 * or disable network-dependent actions.
 */
import { useState, useEffect } from 'react';

export function useConnectivity() {
  const [isOnline, setIsOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true,
  );

  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return { isOnline };
}
